//fill your code here

import React, {useState} from 'react';
import { BrowserRouter as Router, Switch, Route , useHistory } from "react-router-dom";
import LoginHeader from './LoginHeader'
import LoginBody from './LoginBody'
import UserDisplay from './UserDisplay'
import QuestionDisplay from './QuestionDisplay'

function App2 () {

    const [isLogin, setLogin] = useState(false)
    const [currentUser, setCurrentUser ] = useState("")


    const UserLoggedIn = (user) => {
        setCurrentUser(user)
        console.log(user)
        setLogin(true)
    }


    const handleLogout = () => {
        setCurrentUser(null)
        setLogin(false)
        
    }

  return(
    <Router>
      <Switch>
        <Route path='/admin'>
          <LoginHeader userLogin={isLogin} user={currentUser} onLogout={handleLogout}/>
          <UserDisplay  /> 
        </Route>

        <Route path='/user'>
          <LoginHeader userLogin={isLogin} user={currentUser} onLogout={handleLogout}/>
          <QuestionDisplay />
        </Route>

        <Route path='/'>
            <LoginHeader userLogin={isLogin} user={currentUser} onLogout={handleLogout}/>
            <LoginBody onUserLogin={UserLoggedIn} />
        </Route>
      </Switch>
    </Router>
  )
}

export default App2;